import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import home from './modules/home';
import user from './modules/user';
import login from './modules/login';
import order from './modules/order';
import teach from './modules/teach';
import orderManagement from './modules/orderManagement';
import yachtTours from './modules/yachtTours';
import SuperYachtsOrder from './modules/SuperYachtsOrder';
import contact from './modules/contact';
import baseConfig from './modules/baseConfig';
import news from './modules/news';
import teams from './modules/teams';
import receptionSave from './modules/receptionSave';
Vue.use(Vuex);

// // https://webpack.js.org/guides/dependency-management/#requirecontext
// const modulesFiles = require.context('./modules', true, /\.js$/)

// // you do not need `import app from './modules/app'`
// // it will auto require all vuex module from modules file
// const modules = modulesFiles.keys().reduce((modules, modulePath) => {
//   // set './app.js' => 'app'
//   const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
//   const value = modulesFiles(modulePath)
//   modules[moduleName] = value.default
//   return modules
// }, {})

const store = new Vuex.Store({
  modules: {
    home,
    user,
    login,
    order,
    orderManagement,
    yachtTours,
    SuperYachtsOrder,
    teach,
    contact,
    baseConfig,
    news,
    teams,
    receptionSave,
  },
  getters,
});

export default store;
